/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Tariffs And Services Title Styled
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.4.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const TariffsAndServicesTitlePanelStyled = styled.div`
    display: flex;
    flex-direction: row;

    justify-content: space-between;

    background: ${colors.tariffsAndServicesTitlePanelBgColor};
    padding: 16px 24px;
`;
